export interface IImpersonationEndingData {
  impersonatedEmployeeId: number;
  impersonatedEmployeeName: string;
  impersonatorEmployeeId: number;
  impersonatorEmployeeName: string;
  validTo: string;
  daysRemaining: number;
  /** True for the impersonated employee, who granted the impersonation and can extend it. */
  canExtend: boolean;
}

export function isImpersonationEndingData(data: unknown): data is IImpersonationEndingData {
  if (data == null || typeof data !== 'object') {
    return false;
  }

  const candidate = data as Partial<IImpersonationEndingData>;
  return (
    typeof candidate.impersonatedEmployeeId === 'number' &&
    typeof candidate.impersonatedEmployeeName === 'string' &&
    typeof candidate.impersonatorEmployeeId === 'number' &&
    typeof candidate.impersonatorEmployeeName === 'string' &&
    typeof candidate.validTo === 'string' &&
    typeof candidate.daysRemaining === 'number' &&
    typeof candidate.canExtend === 'boolean'
  );
}
